<script setup>
import {computed, getCurrentInstance} from 'vue'
import FormControlPlainText from "../../common/form-control/FormControlPlainText.vue"
import Button from "../../common/Button.vue"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String
})

const {proxy} = getCurrentInstance()
const store = proxy.$store

// --- Computed ---
const id = computed(() => store.state[props.formId].id)

// --- Methods ---
const openAddCreditModal = () => {
    store.dispatch('modals/show', {
        componentName: 'OdpAddCreditModal',
        obj: {
            customerFormId: props.formId,
        }
    })
}

const openDeleteCreditModal = () => {
    store.dispatch('modals/show', {
        componentName: 'OdpDeleteCreditModal',
        obj: {
            customerFormId: props.formId,
        }
    })
}

const openCreditHistoryModal = () => {
    store.dispatch('modals/show', {
        componentName: 'OdpCreditHistoryModal',
        obj: {
            customerId: id.value,
        }
    })
}
</script>

<template>
    <div class="outer">
        <div class="d-flex align-items-center">
            <FormControlPlainText v-if="currentData.creditAmount" class="d-inline m-0" :form-id="formId">
                £{{ currentData.creditAmount }}
            </FormControlPlainText>

            <Button :disabled="!currentData.id" class="btn-sm ms-2" @click.native="openAddCreditModal">
                Add credit
            </Button>

            <Button :disabled="!currentData.id" class="btn-sm ms-2" @click.native="openDeleteCreditModal">
                Delete credit
            </Button>

            <Button class="btn-sm ms-2" @click.native="openCreditHistoryModal">
                View credit history
            </Button>
        </div>
    </div>
</template>

<style scoped>
.outer {
    display: flex;
    align-items: flex-start;
}
</style>